export const styles = {
  chip: {
    backgroundColor: "#CBDCFF",
    ":hover": { backgroundColor: "#AFC1FF" },
  },
};
